import { createSlice } from "@reduxjs/toolkit";
export const freelancerSlice = createSlice({
  name: "freelancerReducer",
  initialState: {
    firstName: null,
    lastName: null,
    phoneNumber: null,
    email: null,
    dob: null,
    country: null,
    city: null,
    citizenship: null,
    jobLookFor: null,
    proffExp: null,
    pJobInt: null,
    pJobExp: null,
    skills: [],
    pHourRate: null,
    pMonthlySalary: null,
    linkedIn: null,
    gitHub: null,
    interestDescription: null,
    resume: null,
    needSupport: null,
    jobDes: null,
    clientFullName: null,
    clientEmail: null,
    clientCountry: null,
    clientPhoneNumber: null,
    clientEmailError: null,
    clientPhoneError: null,

    freelanceEmailError: null,
    freelancePhoneError: null,

    freelancefirstnameError: null,
    freelancelastnameError: null,
    freelancecountryError: null,
    freelancecityError: null,
    freelancecitizenshipError: null,
    freelancebirthdateError: null,
    freelanceexperienceError: null,
    freelancejobtypeError: null,
    freelanceprimaryjobinterestError: null,
    freelanceexperienceyearError: null,
    freelancehourlyrateError: null,
    freelancelinkdinurlError: null,
    freelancegithuburlError: null,
    freelancemonthlysalaryError: null,
  },
  reducers: {
    addFName: (state, action) => {
      state.firstName = action.payload;
    },
    addLName: (state, action) => {
      state.lastName = action.payload;
    },
    addPNum: (state, action) => {
      state.phoneNumber = action.payload;
    },
    addEmail: (state, action) => {
      state.email = action.payload;
    },
    addDob: (state, action) => {
      state.dob = action.payload;
    },
    addCountry: (state, action) => {
      state.country = action.payload;
    },
    addCity: (state, action) => {
      state.city = action.payload;
    },
    addCitizenship: (state, action) => {
      state.citizenship = action.payload;
    },
    //2nd page
    addJobLookFor: (state, action) => {
      state.jobLookFor = action.payload;
    },
    addProffExp: (state, action) => {
      state.proffExp = action.payload;
    },
    addPJobInt: (state, action) => {
      state.pJobInt = action.payload;
    },
    addPJobExp: (state, action) => {
      state.pJobExp = action.payload;
    },
    addSkills: (state, action) => {
      state.skills = action.payload;
    },
    addPHourRate: (state, action) => {
      state.pHourRate = action.payload;
    },
    addPMonthlySalary: (state, action) => {
      state.pMonthlySalary = action.payload;
    },
    addLinkedIn: (state, action) => {
      state.linkedIn = action.payload;
    },
    addGitHub: (state, action) => {
      state.gitHub = action.payload;
    },
    addNeedSupport: (state, action) => {
      state.needSupport = action.payload;
    },
    addJobDes: (state, action) => {
      state.jobDes = action.payload;
    },
    addInterestDescription: (state, action) => {
      state.interestDescription = action.payload;
    },
    addResume: (state, action) => {
      state.resume = action.payload;
    },
    addClientFullName: (state, action) => {
      state.clientFullName = action.payload;
    },
    addClientEmail: (state, action) => {
      state.clientEmail = action.payload;
    },
    addClientCountry: (state, action) => {
      state.clientCountry = action.payload;
    },
    addClientPhoneNumber: (state, action) => {
      state.clientPhoneNumber = action.payload;
    },
    addClientEmailError: (state, action) => {
      state.clientEmailError = action.payload;
    },
    addClientPhoneError: (state, action) => {
      state.clientPhoneError = action.payload;
    },
    addFreelanceEmailError: (state, action) => {
      state.freelanceEmailError = action.payload;
    },
    addFreelancePhoneError: (state, action) => {
      state.freelancePhoneError = action.payload;
    },
    // ================>
    addFirstnameError: (state, action) => {
      state.freelancefirstnameError = action.payload;
    },
    addLastnameError: (state, action) => {
      state.freelancelastnameError = action.payload;
    },
    addCountryError: (state, action) => {
      state.freelancecountryError = action.payload;
    },
    addCityError: (state, action) => {
      state.freelancecityError = action.payload;
    },
    addCitizenshipError: (state, action) => {
      state.freelancecitizenshipError = action.payload;
    },
    addDobError: (state, action) => {
      state.freelancebirthdateError = action.payload;
    },
    addExperienceError: (state, action) => {
      state.freelanceexperienceError = action.payload;
    },
    addJobtypeError: (state, action) => {
      state.freelancejobtypeError = action.payload;
    },
    addPriJobInterestError: (state, action) => {
      state.freelanceprimaryjobinterestError = action.payload;
    },
    addExperienceYearError: (state, action) => {
      state.freelanceexperienceyearError = action.payload;
    },
    addHourlyrateError: (state, action) => {
      state.freelancehourlyrateError = action.payload;
    },
    addMonthlysalaryError: (state, action) => {
      state.freelancemonthlysalaryError = action.payload;
    },
    addLinkedinURLError: (state, action) => {
      state.freelancelinkdinurlError = action.payload;
    },
    addGithubURLError: (state, action) => {
      state.freelancegithuburlError = action.payload;
    },
  },
});

export const {
  addFreelanceEmailError,
  addFreelancePhoneError,
  addClientEmailError,
  addClientPhoneError,
  addClientPhoneNumber,
  addClientCountry,
  addClientEmail,
  addClientFullName,
  addInterestDescription,
  addResume,
  addJobDes,
  addNeedSupport,
  addFName,
  addLName,
  addPNum,
  addEmail,
  addDob,
  addCountry,
  addCity,
  addCitizenship,
  addJobLookFor,
  addProffExp,
  addPJobInt,
  addPJobExp,
  addSkills,
  addPHourRate,
  addPMonthlySalary,
  addLinkedIn,
  addGitHub,
  addFirstnameError,
  addLastnameError,
  addCountryError,
  addCityError,
  addCitizenshipError,
  addDobError,
  addExperienceError,
  addJobtypeError,
  addPriJobInterestError,
  addExperienceYearError,
  addHourlyrateError,
  addMonthlysalaryError,
  addLinkedinURLError,
  addGithubURLError,
} = freelancerSlice.actions;
export const selectFreelance = (state) => state.freelancer;
export default freelancerSlice.reducer;
